var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelMiniIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#217346"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10H15C14.4477 10 14 10.4477 14 11V29C14 29.5523 14.4477 30 15 30H25C25.5523 30 26 29.5523 26 29V15.5L22.5 10Z",
    fill: "#21A366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10V15.5H26L22.5 10Z",
    fill: "#33C481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.5H22.5V10L26 15.5Z",
    fill: "#33C481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20L18.5 22.5L16.5 25H18.5L20 23L21.5 25H23.5L21.5 22.5L23.5 20H21.5L20 22L18.5 20H16.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5H15V28.5H25V15H20V11.5Z",
    fill: "#107C41",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelMiniIcon);
export default __webpack_public_path__ + "static/media/excelMiniIcon.1b007006f9cf5caeb5817dcf6a55aa06.svg";
export { ForwardRef as ReactComponent };